var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.facets),function(facet){return _c('v-sheet',{key:facet.key,staticClass:"mb-4",attrs:{"outlined":"","rounded":"lg"}},[_c('SearchFacetList',{attrs:{"faceted-search":_vm.facetedSearch,"facet":facet}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }